// Base config.
// There is still be a lot of special magic, but some things can be configured.

// sources
// Data sources configuration.
// "special" means that the app has a special knowledge how to obtain the,
// it is used for data coming not from MQTT, but from server API
// MQTT sources, as a rule, can be configured in more general way, so it is
// possible to specify more new sources here.
// "format" is the format of a message from MQTT.
// "dataFields" is the list of fields in the message
// For transformed sources:
// "transform" is key to the transformer on the backend
// "source" is the source of the transformer
//
//
// "styles" and "sizes" are defaults for charts (some are overriden in CHARTS)
// "x" and "y" are defaults for charts axes. The properties here are:
// "format" - format of tick labels, function, that takes actual value
// on the axis and coverts it to desired displayed format. Function
// is called in the chart context (basically, that means the chart object is
// "this"), so you can use the chart properties in this function.
// "unit" is unit of axes values, string of function.
// "range" is max range of the chart. Chart is auto-scaled according to its
// max and min values, but its range can't be out that specified in config.
// "ticks" are primary ticks.
//  "secondaryTicks" are smaller ticks between  primary, the configuration
// value is number  of secondary ticks between two primary ticks minus 1.
// So, `"secondaryTicks": 1` means no secondary ticks.
// "stats" and "meteo" is list of statistics and meteo fields,
// "stats_past" are statistics displayed on camera tabs.
//
import templates from "./templates";

export default {
    // Tab selected when the interface is just open
    startTab: "pitch",
    // Period selected when the interface is just open
    period: 300000,
    initFunctions: [],
    exportData: {
        // show the button at top to open export dialog
        enable: true,
        // tables columns config, need to be updated
        tables: {
            imu: {
                label: "IMU",
                columns: [
                    "sensor_id",
                    "time",
                    "time_startup",
                    "yaw",
                    "pitch",
                    "roll",
                    "ang_rate_x",
                    "ang_rate_y",
                    "ang_rate_z",
                    "d_time",
                    "d_th_x",
                    "d_th_y",
                    "d_th_z",
                    "d_v_x",
                    "d_v_y",
                    "d_v_z",
                    "temp",
                    "lin_body_acc_x",
                    "lin_body_acc_y",
                    "lin_body_acc_z",
                    "lin_ned_acc_x",
                    "lin_ned_acc_y",
                    "lin_ned_acc_z",
                    "heave",
                    "heave_rate",
                    "delayed_heave",
                ],
                defaultSelection: ["sensor_id", 'time', 'yaw', 'pitch', 'roll', 'heave'],
            },
            gps: {
                label: "GPS",
                columns: [
                    "sensor_id",
                    "time",
                    "year",
                    "month",
                    "day",
                    "hour",
                    "min",
                    "sec",
                    "valid",
                    "tAcc",
                    "nano",
                    "numSV",
                    "lon",
                    "lat",
                    "height",
                    "hMSL",
                    "hAcc",
                    "vAcc",
                    "velN",
                    "velE",
                    "velD",
                    "gSpeed",
                    "headMot",
                    "sAcc",
                    "headAcc",
                    "pDOP",
                    "headVeh",
                    "magDec",
                    "magAcc",
                    "relPosN",
                    "relPosE",
                    "relPosD",
                    "relPosLength",
                    "heading",
                    "relPosHPN",
                    "relPosHPE",
                    "relPosHPD",
                    "relPosHPLength",
                    "accN",
                    "accE",
                    "accD",
                    "accLength",
                    "accHeading",
                ],
                defaultSelection: [
                    "sensor_id", "time", "lon", "lat", "relPosN", "relPosE", "heading",
                ],
            }
        },
    },
    // camera props may be changed
    camera: {
        mediaTypes: ["photo", "video"],
    },
    // common chart style
    chartStyle: {},
    // default meteo data (tiles at left)
    meteo: [{
        key: "wavePeriod",
        label: "Tp",
        unit: "s"
    }, {
        key: "waveHeight",
        label: "Hs",
        unit: "m"
    }, {
        key: "windSpeed",
        label: "Wind",
        unit: "m/s"
    }],
    // old, will do something with it
    stats_past: [{
        key: "max_roll",
        label: "Max roll",
        unit: "deg"
    }, {
        key: "avg_roll",
        label: "Mean roll",
        unit: "deg"
    }, {
        key: "max_pitch",
        label: "Max pitch",
        unit: "deg"
    }, {
        key: "avg_pitch",
        label: "Mean pitch",
        unit: "deg"
    }, {
        key: "max_heave",
        label: "Max heave",
        unit: "m"
    }, {
        key: "avg_heave",
        label: "Mean heave",
        unit: "m"
    }],
    // default periods to select (at left top), in ms
    periods: [300, 1800, 3600, 86400],
    // tab templates
    templates,
    // in ms
    refreshPeriod: {
        database: 6e4,
        charts: 50
    },
    tabGroups: {},
    // the most interesting part
    tabs: {
        // <tab_key>: {
        //   Override default props:
        //      layout: {...}
        //      periods: [...]
        //
        //      stats: True - use default stats
        //      stats: [ ... ] - override stats
        //      stats omitted - dont display stats at left
        //      same for meteo!
        //
        //      label: "Tab title"
        //      components defined in layout
        //      components:  {
        //          template: "key_to_template",
        //          props: {...}  - override template props
        //      }
        // }

    }
};

